import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberValue'
})
export class FormatNumberValuePipe implements PipeTransform {

  transform(value: any): string {
    if (value > 0) {
      return `+${value}`;
    }
    return `${value}`;
  }

}
